import React from "react";
import { Div } from "atomize";
import { graphql } from "gatsby";

import Header from "../components/common/Header";

import Layout from "../components/common/layout";
import CreatorsHero from "../components/influencers/CreatorsHero";
import InfluencersNetwork from "../components/influencers/InfluencersNetwork";
import InfluencerDataBase from "../components/influencers/InfluencerDataBase";
import InfluencersJoin from "../components/influencers/InfluencersJoin";
import InfluencersPhone from "../components/influencers/InfluencersPhone";
import InfluencersHow from "../components/influencers/InfluencersHow";
import InfluencersApply from "../components/influencers/InfluencersApply";
import Footer from "../components/common/Footer";
import SEO from "../components/seo";
import CreatorsDashboard from "../components/influencers/CreatorsDashboard";

const Influencers = ({ data }) => {
  return (
    <Layout>
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <SEO
        seo={data.contentfulCreatorsPage.seo}
        url="https://trend.io/creators"
      />
      <Div>
        <CreatorsHero
          bgImg={data.contentfulCreatorsPage.heroMainImage}
          title={data.contentfulCreatorsPage.heroTitle}
          description={data.contentfulCreatorsPage.heroDescription}
          label={data.contentfulCreatorsPage.heroApplyBtnLabel}
          subImages={data.contentfulCreatorsPage.heroSubImages}
          subText={data.contentfulCreatorsPage.heroSubText1}
        />
        <CreatorsDashboard
          title={data.contentfulCreatorsPage.dashboardTitle}
          heading={data.contentfulCreatorsPage.dashboardHeading}
          points={data.contentfulCreatorsPage.dashboardPoints}
        />
        <Div
          m={{ x: { md: "2.5rem", xs: "1.5rem" } }}
          // p={{ y: { lg: "2.5rem" } }}
        >
          <InfluencersNetwork
            title={data.contentfulCreatorsPage.title}
            label={data.contentfulCreatorsPage.applyBtnLabel}
            testimonials={data.contentfulCreatorsPage.testimonials}
          />
        </Div>
        <Div
          m={{ y: "4rem", x: { lg: "0", md: "2.5rem" } }}
          p={{ y: { lg: "2.5rem" } }}
        >
          <InfluencerDataBase
            title={data.contentfulCreatorsPage.newSystemHeading}
            differences={data.contentfulCreatorsPage.differences}
          />
        </Div>
        <Div
          p={{ y: "2.5rem" }}
          m={{ b: "4rem", x: "2.5rem" }}
          p={{ y: { lg: "2.5rem" } }}
        >
          <InfluencersJoin
            title={data.contentfulCreatorsPage.joinSectionTitle}
            label={data.contentfulCreatorsPage.joinSectionBtnLabel}
          />
        </Div>
        <Div p={{ x: { lg: "0", md: "2.5rem" } }} p={{ y: { lg: "2.5rem" } }}>
          <InfluencersPhone
            title={data.contentfulCreatorsPage.appSectionTitle}
            image={data.contentfulCreatorsPage.appSectionImage}
            features={
              data.contentfulCreatorsPage.appSectionFeatures.appSectionFeatures
            }
            footerTitle={data.contentfulCreatorsPage.appSectionBadgesTitle}
          />
        </Div>
        <Div m={{ t: "2rem" }} p={{ y: { lg: "2.5rem" } }}>
          <InfluencersHow
            howItWorks={data.contentfulCreatorsPage.howItWorks}
            images={data.contentfulCreatorsPage.applySectionImages}
          />
        </Div>
        <Div
          m={{ y: "4rem", x: { lg: "0", md: "2.5rem", xs: "1.5rem" } }}
          p={{ y: { lg: "2.5rem" } }}
        >
          <InfluencersApply
            title={
              data.contentfulCreatorsPage.applySectionDescription
                .applySectionDescription
            }
          />
        </Div>
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query CreatorPageQuery {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulCreatorsPage {
      heroMainImage {
        file {
          url
        }
      }
      heroTitle
      heroDescription
      heroApplyBtnLabel
      heroSubImages {
        file {
          url
        }
      }
      heroSubText1 {
        text
      }

      dashboardTitle
      dashboardHeading
      dashboardPoints {
        heading
        info
        image
      }

      title
      applyBtnLabel
      testimonials {
        user
        image {
          file {
            url
          }

          description
        }
        testimonial {
          testimonial
        }
      }
      newSystemHeading
      differences {
        other
        trend
      }
      joinSectionTitle
      joinSectionBtnLabel
      appSectionTitle
      appSectionImage {
        file {
          url
        }
        description
      }
      appSectionFeatures {
        appSectionFeatures
      }
      appSectionBadgesTitle
      howItWorks {
        title
        description {
          description
        }
      }
      applySectionDescription {
        applySectionDescription
      }
      applySectionImages {
        file {
          url
        }
        description
      }

      seo {
        ...SeoFragment
      }
    }
  }
`;

export default Influencers;
